import toast from 'react-hot-toast';
import Core from '../core';
import { Axios, AxiosError, AxiosResponse } from 'axios';
const version = 'v2';

async function createSuggestion(payload: any) {
  const api = Core.getInstance().apiforImageUp();
  try {
    const data = await api.post(`/${version}/createSuggestion`, payload);

    if (data instanceof AxiosError) {
      return data.response;
    }
    const response = data.data;
    return response;
  } catch (error: any) {
    console.error(error);
  }
}

function getSuggestionStatusDetails(suggestionrefId: any, companyId: any) {
  return new Promise((resolve, reject) => {
    const api = Core.getInstance().api();
    api
      .get(
        `/v2/suggestion-status-details?suggestionrefId=${suggestionrefId}&comapny_id=${companyId}&locale=${localStorage.getItem(
          'applang',
        )}`,
      )
      .then((result) => {
        return resolve(result.data.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

async function getSuggestionList(
  company_id: number,
  emp_id: number,
  page: number,
  limit: number,
  searchTerm: string,
) {
  const api = Core.getInstance().api();
  try {
    const data = await api.get(
      `/${version}/listSuggestion?company_id=${company_id}&emp_id=${emp_id}&page=${page}&limit=${limit}&searchTerm=${searchTerm}&locale=${localStorage.getItem(
        'emplang',
      )}`,
    );

    if (data instanceof AxiosError) {
      return data.response;
    }
    const response = data?.data;
    return response;
  } catch (error: any) {
    console.error(error, 'Error occurred');
    toast.error(error);
  }
}
async function suggestionRoleEmpList(company_id: number) {
  const api = Core.getInstance().api();
  try {
    const data = await api.get(
      `/${version}/suggestion-role-emp-list?company_id=${company_id}&locale=${localStorage.getItem(
        'emplang',
      )}`,
    );

    if (data instanceof AxiosError) {
      return data.response;
    }
    const response = data?.data;
    return response;
  } catch (error: any) {
    console.error(error, 'Error occurred');
    toast.error(error);
  }
}
async function updateSuggestionbyEmp(payload: any) {
  const api = Core.getInstance().apiforImageUp();
  try {
    const data = await api.post(`/${version}/updateSuggestionbyEmp`, payload);

    if (data instanceof AxiosError) {
      return data.response;
    }
    const response = data.data;
    return response;
  } catch (error: any) {
    console.error(error);
  }
}
export const suggestionService = {
  createSuggestion,
  getSuggestionList,
  suggestionRoleEmpList,
  getSuggestionStatusDetails,
  updateSuggestionbyEmp,
};
